// @flow

export const TOOLTIP_TYPES = {
  HOLDING_DEPOSIT: 'holding_deposit',
  SECURITY_BOND: 'security_bond'
}

const tooltipData = {
  [TOOLTIP_TYPES.HOLDING_DEPOSIT]: {
    title: 'Holding deposit',
    content:
      'In order to reserve a room and take it off the market for you, we’re asking for a holding deposit. But don’t worry, this isn’t any extra cost as it will be used towards your security bond that you pay before moving in with us.'
  },
  [TOOLTIP_TYPES.SECURITY_BOND]: {
    title: 'Security bond',
    content:
      'The Security Bond is a deposit for the room that will be held on trust for the Member by The Collective to make sure no damage is made to the room during the stay.'
  }
}

export default tooltipData



// WEBPACK FOOTER //
// ./src/ducks/Tooltips/TooltipData.js